import React from 'react';

const LanguageSelect = ({
  id = 'language',
  label = 'Proceeding language',
  value,
  onChange,
  languages,
  required = true,
  disabled = false,
  locked = false,
  helperText,
}) => (
  <div>
    <label htmlFor={id} className="block text-sm font-medium text-legal-700 mb-2">
      {label} {required && <span className="text-red-500">*</span>}
      {locked && (
        <span className="ml-2 text-xs font-normal text-legal-500">(locked for this session)</span>
      )}
    </label>
    <select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled || locked}
      className="w-full px-3 py-2 border border-legal-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-court-500 focus:border-court-500 text-sm disabled:bg-legal-50 disabled:text-legal-500"
    >
      <option value="">Select language…</option>
      {languages.map((lang) => (
        <option
          key={lang.code}
          value={lang.label}
          disabled={lang.restricted}
          title={lang.restricted ? 'Below accuracy threshold — restricted to draft only' : undefined}
        >
          {lang.label}{lang.restricted ? ' (restricted)' : ''}
        </option>
      ))}
    </select>
    {helperText && (
      <p className="mt-1 text-xs text-legal-500">{helperText}</p>
    )}
  </div>
);

export default LanguageSelect;
